// Lightweight i18n — three languages, key-based lookup with English fallback
export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "hi", label: "हि", name: "हिन्दी" },
  { code: "mr", label: "मरा", name: "मराठी" },
];

const dict = {
  // Navigation
  "nav.discover": { en: "Discover", hi: "खोजें", mr: "शोधा" },
  "nav.matches": { en: "Matches", hi: "मैच", mr: "जोड्या" },
  "nav.interests": { en: "Interests", hi: "रुचियाँ", mr: "स्वारस्य" },
  "nav.dashboard": { en: "Dashboard", hi: "डैशबोर्ड", mr: "डॅशबोर्ड" },
  "nav.premium": { en: "Premium", hi: "प्रीमियम", mr: "प्रीमियम" },
  "nav.profile": { en: "My Profile", hi: "मेरी प्रोफ़ाइल", mr: "माझी प्रोफाइल" },
  "nav.signin": { en: "Sign in", hi: "साइन इन", mr: "साइन इन" },
  "nav.join": { en: "Join us", hi: "हमसे जुड़ें", mr: "सामील व्हा" },
  "nav.logout": { en: "Logout", hi: "लॉगआउट", mr: "लॉगआउट" },

  // Landing
  "landing.overline": { en: "A modern matrimony — est. 2026", hi: "आधुनिक विवाह — स्थापना 2026", mr: "आधुनिक विवाह — स्थापना 2026" },
  "landing.title1": { en: "Find the one", hi: "ढूंढिए उन्हें", mr: "शोधा त्यांना" },
  "landing.title2": { en: "who feels like", hi: "जो लगते हैं जैसे", mr: "जे वाटतात जणू" },
  "landing.title3": { en: "home", hi: "घर", mr: "घर" },
  "landing.subtitle": {
    en: "Sanyog is a quiet place for considered introductions. No swipes, no vanity metrics — just thoughtful profiles, honest conversations, and the kind of connection your grandparents would have approved of.",
    hi: "संयोग सोच-समझकर परिचय कराने की एक शांत जगह है। न स्वाइप, न दिखावटी आँकड़े — सिर्फ़ ईमानदार प्रोफ़ाइलें, सच्ची बातचीत और ऐसा रिश्ता जिसे आपके दादा-दादी भी पसंद करते।",
    mr: "संयोग म्हणजे विचारपूर्वक ओळख करून देणारी एक शांत जागा. ना स्वाइप, ना दिखाव्याची आकडेवारी — फक्त प्रामाणिक प्रोफाइल, खरी संभाषणे आणि अशी ओळख जी तुमच्या आजी-आजोबांनाही आवडली असती."
  },
  "landing.ctaCreate": { en: "Create your profile", hi: "अपनी प्रोफ़ाइल बनाएं", mr: "तुमची प्रोफाइल तयार करा" },
  "landing.ctaHave": { en: "I already have an account", hi: "मेरा खाता पहले से है", mr: "माझे खाते आधीच आहे" },
  "landing.pillar1.kicker": { en: "01 · Intentional", hi: "01 · सोच-समझकर", mr: "01 · विचारपूर्वक" },
  "landing.pillar1.title": { en: "Profiles that read like people", hi: "ऐसी प्रोफ़ाइलें जो असली लगें", mr: "खऱ्या व्यक्तींसारख्या प्रोफाइल" },
  "landing.pillar1.body": {
    en: "Long-form bios, family context, partner preferences. We make space for the things that actually matter.",
    hi: "विस्तृत परिचय, परिवार, साथी की पसंद। हम उन बातों को महत्व देते हैं जो वाक़ई मायने रखती हैं।",
    mr: "सविस्तर माहिती, कुटुंब, जोडीदाराची आवड. खरोखर महत्त्वाच्या गोष्टींना आम्ही जागा देतो."
  },
  "landing.pillar2.kicker": { en: "02 · Private", hi: "02 · निजी", mr: "02 · खाजगी" },
  "landing.pillar2.title": { en: "Chat after a mutual yes", hi: "दोनों की हाँ के बाद ही बातचीत", mr: "दोघांच्या होकारानंतरच गप्पा" },
  "landing.pillar2.body": {
    en: "No cold messages. Conversation opens only when both of you express interest — quiet by design.",
    hi: "बेमतलब संदेश नहीं। बातचीत तभी शुरू होती है जब दोनों रुचि दिखाएँ।",
    mr: "उगाच मेसेज नाहीत. दोघांनी रस दाखवल्यावरच गप्पा सुरू होतात."
  },
  "landing.pillar3.kicker": { en: "03 · Curated", hi: "03 · चुनी हुई", mr: "03 · निवडक" },
  "landing.pillar3.title": { en: "A small, beautiful pool", hi: "एक छोटा, सुंदर समूह", mr: "एक छोटा, सुंदर गट" },
  "landing.pillar3.body": {
    en: "No infinite scrolling. Discover a hand-picked grid of compatible profiles you can actually consider.",
    hi: "अंतहीन स्क्रॉल नहीं। चुनिंदा अनुकूल प्रोफ़ाइलों का संग्रह।",
    mr: "अनंत स्क्रॉल नाही. निवडक, अनुरूप प्रोफाइलचा संग्रह."
  },
  "landing.bottom.title": { en: "Worth taking your time on.", hi: "ध्यान देने योग्य है।", mr: "इथे वेळ देणे योग्य आहे." },
  "landing.bottom.body": {
    en: "Marriage is a long sentence. Sanyog is the place to find the right co-author.",
    hi: "विवाह एक लम्बी कहानी है। संयोग आपके सह-लेखक को ढूँढने की जगह है।",
    mr: "विवाह ही लांबलचक कथा आहे. संयोग म्हणजे योग्य सह-लेखक शोधण्याची जागा."
  },
  "landing.bottom.cta": { en: "Begin now", hi: "अभी शुरू करें", mr: "आता सुरू करा" },

  // Auth
  "login.title": { en: "Welcome back.", hi: "पुनः स्वागत है।", mr: "पुन्हा स्वागत आहे." },
  "login.email": { en: "Email", hi: "ईमेल", mr: "ईमेल" },
  "login.password": { en: "Password", hi: "पासवर्ड", mr: "पासवर्ड" },
  "login.submit": { en: "Sign in", hi: "साइन इन", mr: "साइन इन" },
  "login.submitting": { en: "Signing in…", hi: "साइन इन हो रहा है…", mr: "साइन इन होत आहे…" },
  "login.new": { en: "New here?", hi: "पहली बार आए हैं?", mr: "पहिल्यांदा आला आहात?" },
  "login.create": { en: "Create an account", hi: "खाता बनाएं", mr: "खाते तयार करा" },
  "login.side": { en: "Pick up where you left off — your next conversation is waiting.", hi: "जहाँ रुके थे वहीं से शुरू करें — अगली बातचीत इंतज़ार में है।", mr: "जिथे थांबला होतात तिथून सुरू करा — पुढची गप्पा वाट पाहत आहे." },

  "register.title": { en: "A few details to begin.", hi: "कुछ जानकारी से शुरू करें।", mr: "थोडी माहिती देऊन सुरुवात करा." },
  "register.subtitle": { en: "You can fill in the rest of your story next.", hi: "बाकी कहानी आप आगे जोड़ सकते हैं।", mr: "उरलेली कथा तुम्ही पुढे जोडू शकता." },
  "register.name": { en: "Full name", hi: "पूरा नाम", mr: "पूर्ण नाव" },
  "register.iam": { en: "I am a", hi: "मैं हूँ", mr: "मी आहे" },
  "register.man": { en: "Man", hi: "पुरुष", mr: "पुरुष" },
  "register.woman": { en: "Woman", hi: "स्त्री", mr: "स्त्री" },
  "register.submit": { en: "Create account", hi: "खाता बनाएं", mr: "खाते तयार करा" },
  "register.creating": { en: "Creating…", hi: "बनाया जा रहा है…", mr: "तयार होत आहे…" },
  "register.have": { en: "Already a member?", hi: "पहले से सदस्य हैं?", mr: "आधीच सभासद आहात?" },

  // Browse
  "browse.kicker": { en: "Discover", hi: "खोजें", mr: "शोधा" },
  "browse.title": { en: "A small gallery of possibilities.", hi: "संभावनाओं की एक छोटी गैलरी।", mr: "शक्यतांची एक छोटी गॅलरी." },
  "browse.subtitle": { en: "Profiles below are shown opposite to your gender. Use filters to narrow with intent.", hi: "नीचे विपरीत लिंग की प्रोफ़ाइलें दिख रही हैं। फ़िल्टर से चुनें।", mr: "खाली विरुद्ध लिंगाच्या प्रोफाइल दिसत आहेत. फिल्टर वापरून निवडा." },
  "browse.search": { en: "Search name, profession…", hi: "नाम, पेशा खोजें…", mr: "नाव, व्यवसाय शोधा…" },
  "browse.any_religion": { en: "Any religion", hi: "कोई भी धर्म", mr: "कोणताही धर्म" },
  "browse.city": { en: "City", hi: "शहर", mr: "शहर" },
  "browse.min_age": { en: "Min age", hi: "न्यून आयु", mr: "किमान वय" },
  "browse.max_age": { en: "Max age", hi: "अधि. आयु", mr: "कमाल वय" },
  "browse.apply": { en: "Apply filters", hi: "फ़िल्टर लागू करें", mr: "फिल्टर लागू करा" },
  "browse.empty.title": { en: "No matches yet.", hi: "अभी कोई मैच नहीं।", mr: "अजून कोणताही मॅच नाही." },
  "browse.empty.body": { en: "Try adjusting your filters — or invite a friend to join.", hi: "फ़िल्टर बदलकर देखें — या किसी मित्र को आमंत्रित करें।", mr: "फिल्टर बदलून पहा — किंवा मित्राला आमंत्रित करा." },

  // Common
  "common.years": { en: "yrs", hi: "वर्ष", mr: "वर्षे" },
  "common.loading": { en: "Loading…", hi: "लोड हो रहा है…", mr: "लोड होत आहे…" },

  // Dashboard
  "dash.kicker": { en: "Dashboard", hi: "डैशबोर्ड", mr: "डॅशबोर्ड" },
  "dash.hello": { en: "Hello", hi: "नमस्ते", mr: "नमस्कार" },
  "dash.incomplete.title": { en: "Your profile isn't visible yet.", hi: "आपकी प्रोफ़ाइल अभी दिख नहीं रही।", mr: "तुमची प्रोफाइल अद्याप दिसत नाही." },
  "dash.incomplete.body": { en: "Add at least your date of birth, religion, city, education, profession & about-me to appear in discovery.", hi: "खोज में आने के लिए कम से कम जन्मतिथि, धर्म, शहर, शिक्षा, पेशा और परिचय जोड़ें।", mr: "शोधात येण्यासाठी किमान जन्मतारीख, धर्म, शहर, शिक्षण, व्यवसाय व परिचय जोडा." },
  "dash.complete": { en: "Complete profile", hi: "प्रोफ़ाइल पूरी करें", mr: "प्रोफाइल पूर्ण करा" },
  "dash.sent": { en: "Interests sent", hi: "भेजी रुचियाँ", mr: "पाठवलेले स्वारस्य" },
  "dash.received": { en: "Interests received", hi: "प्राप्त रुचियाँ", mr: "मिळालेले स्वारस्य" },
  "dash.matchesLabel": { en: "Mutual matches", hi: "आपसी मैच", mr: "परस्पर जोड्या" },
  "dash.views": { en: "Profile views", hi: "प्रोफ़ाइल दर्शन", mr: "प्रोफाइल दर्शन" },
  "dash.todayKicker": { en: "Today", hi: "आज", mr: "आज" },
  "dash.todayTitle": { en: "Discover today's gallery", hi: "आज की गैलरी देखें", mr: "आजची गॅलरी पहा" },
  "dash.todayBody": { en: "A new set of carefully matched profiles, every day.", hi: "हर दिन सावधानी से चुनी गई प्रोफ़ाइलें।", mr: "दररोज काळजीपूर्वक निवडलेल्या प्रोफाइल." },
  "dash.convKicker": { en: "Conversations", hi: "बातचीत", mr: "गप्पा" },
  "dash.convTitle": { en: "Chat with your matches", hi: "अपने मैच से बात करें", mr: "तुमच्या जोडीदाराशी गप्पा" },
  "dash.convBody": { en: "Pick up the thread with people who said yes back.", hi: "जिन्होंने हाँ कही है, उनसे बात आगे बढ़ाएं।", mr: "ज्यांनी होकार दिला त्यांच्याशी संवाद सुरू ठेवा." },

  // Matches
  "matches.kicker": { en: "Mutual matches", hi: "आपसी मैच", mr: "परस्पर जोड्या" },
  "matches.title": { en: "People who said yes back.", hi: "जिन्होंने हाँ कही।", mr: "ज्यांनी होकार दिला." },
  "matches.empty": { en: "No matches yet. Send a few interests to begin.", hi: "अभी कोई मैच नहीं। कुछ रुचियाँ भेजकर शुरू करें।", mr: "अद्याप कोणताही मॅच नाही. काही स्वारस्य पाठवून सुरुवात करा." },
  "matches.openChat": { en: "Open chat", hi: "बातचीत खोलें", mr: "गप्पा सुरू करा" },

  // Interests
  "interests.kicker": { en: "Interests", hi: "रुचियाँ", mr: "स्वारस्य" },
  "interests.title": { en: "Who's been thinking of whom.", hi: "कौन किसके बारे में सोच रहा है।", mr: "कोण कोणाचा विचार करत आहे." },
  "interests.empty": { en: "Nothing here yet.", hi: "अभी कुछ नहीं।", mr: "अद्याप काही नाही." },
  "interests.tabReceived": { en: "received", hi: "प्राप्त", mr: "मिळालेले" },
  "interests.tabSent": { en: "sent", hi: "भेजे गए", mr: "पाठवलेले" },
  "interests.accept": { en: "Accept", hi: "स्वीकारें", mr: "स्वीकारा" },
  "interests.decline": { en: "Decline", hi: "अस्वीकार", mr: "नाकारा" },

  // Chat
  "chat.placeholder": { en: "Write a message…", hi: "संदेश लिखें…", mr: "संदेश लिहा…" },
  "chat.sayHello": { en: "Say hello.", hi: "नमस्ते कहें।", mr: "नमस्कार म्हणा." },
  "chat.sayHelloBody": { en: "A thoughtful opener goes a long way.", hi: "एक अच्छी शुरुआत बहुत फ़र्क़ डालती है।", mr: "चांगली सुरुवात खूप फरक करते." },
  "chat.back": { en: "Back to matches", hi: "मैच पर वापस", mr: "जोड्यांकडे परत" },

  // MyProfile
  "mp.kicker.edit": { en: "My profile", hi: "मेरी प्रोफ़ाइल", mr: "माझी प्रोफाइल" },
  "mp.kicker.welcome": { en: "Welcome", hi: "स्वागत है", mr: "स्वागत आहे" },
  "mp.title.edit": { en: "Edit your profile.", hi: "अपनी प्रोफ़ाइल संपादित करें।", mr: "तुमची प्रोफाइल संपादित करा." },
  "mp.title.welcome": { en: "Tell us about yourself.", hi: "अपने बारे में बताएं।", mr: "स्वतःबद्दल सांगा." },
  "mp.subtitle": { en: "These details help others know you better. A complete profile appears in discovery.", hi: "ये जानकारियाँ दूसरों को आपको बेहतर जानने में मदद करती हैं।", mr: "ही माहिती इतरांना तुम्हाला अधिक चांगले जाणून घेण्यास मदत करते." },
  "mp.photos": { en: "Photos", hi: "तस्वीरें", mr: "फोटो" },
  "mp.save": { en: "Save profile", hi: "प्रोफ़ाइल सहेजें", mr: "प्रोफाइल जतन करा" },

  // Premium page
  "prem.kicker": { en: "Sanyog Premium", hi: "संयोग प्रीमियम", mr: "संयोग प्रीमियम" },
  "prem.title": { en: "Quiet, but with more open doors.", hi: "शांत, पर अधिक खुले दरवाज़े।", mr: "शांत, पण अधिक खुले दरवाजे." },
  "prem.subtitle": { en: "A modest upgrade for those serious about finding the right person — faster, smarter, with more insight.", hi: "सही साथी ढूँढने के लिए गंभीर लोगों के लिए एक संयमित उन्नयन।", mr: "योग्य जोडीदार शोधण्यासाठी गंभीर लोकांसाठी एक संयमी अपग्रेड." },
  "prem.already": { en: "You're already a Premium member.", hi: "आप पहले से प्रीमियम सदस्य हैं।", mr: "तुम्ही आधीच प्रीमियम सभासद आहात." },
  "prem.plan": { en: "Plan", hi: "योजना", mr: "योजना" },
  "prem.monthly": { en: "Monthly", hi: "मासिक", mr: "मासिक" },
  "prem.annual": { en: "Annual", hi: "वार्षिक", mr: "वार्षिक" },
  "prem.recommended": { en: "Recommended", hi: "अनुशंसित", mr: "शिफारस केलेले" },
  "prem.save34": { en: "Save 32%", hi: "32% बचाएं", mr: "32% बचवा" },
  "prem.choose": { en: "Choose", hi: "चुनें", mr: "निवडा" },
  "prem.redirecting": { en: "Redirecting…", hi: "रीडायरेक्ट हो रहा है…", mr: "रीडायरेक्ट होत आहे…" },
  "prem.youArePremium": { en: "You're Premium", hi: "आप प्रीमियम हैं", mr: "तुम्ही प्रीमियम आहात" },
  "prem.secureBy": { en: "Secure checkout by Stripe. Cancel anytime.", hi: "Stripe द्वारा सुरक्षित भुगतान। कभी भी रद्द करें।", mr: "Stripe द्वारे सुरक्षित पेमेंट. कधीही रद्द करा." },
  "prem.perks.0": { en: "See who viewed your profile", hi: "देखें कौन आपकी प्रोफ़ाइल देख रहा है", mr: "तुमची प्रोफाइल कोणी पाहिली ते पहा" },
  "prem.perks.1": { en: "Unlimited interests per day", hi: "रोज़ असीमित रुचियाँ", mr: "दररोज अमर्यादित स्वारस्य" },
  "prem.perks.2": { en: "Priority in discovery results", hi: "खोज में प्राथमिकता", mr: "शोधात प्राधान्य" },
  "prem.perks.3": { en: "AI compatibility on every match", hi: "हर मैच पर AI संगति", mr: "प्रत्येक मॅचवर AI सुसंगती" },
  "prem.perks.4": { en: "Verified profile badge", hi: "सत्यापित बैज", mr: "सत्यापित बॅज" },
  "prem.perks.5": { en: "Access to detailed Kundli matching", hi: "विस्तृत कुंडली मिलान", mr: "तपशीलवार कुंडली जुळवणी" },

  // ProfileDetail
  "pd.profile": { en: "Profile", hi: "प्रोफ़ाइल", mr: "प्रोफाइल" },
  "pd.back": { en: "← Back to discover", hi: "← खोज पर वापस", mr: "← शोधाकडे परत" },
  "pd.verified": { en: "Verified", hi: "सत्यापित", mr: "सत्यापित" },
  "pd.openChat": { en: "Open chat", hi: "बातचीत खोलें", mr: "गप्पा सुरू करा" },
  "pd.interestSent": { en: "Interest sent · awaiting response", hi: "रुचि भेजी · प्रतीक्षा में", mr: "स्वारस्य पाठवले · प्रतीक्षेत" },
  "pd.theySent": { en: "They sent you an interest — view it", hi: "उन्होंने आपको रुचि भेजी है — देखें", mr: "त्यांनी तुम्हाला स्वारस्य पाठवले — पहा" },
  "pd.notInterested": { en: "Not interested at this time", hi: "इस समय रुचि नहीं", mr: "सध्या स्वारस्य नाही" },
  "pd.sending": { en: "Sending…", hi: "भेजा जा रहा है…", mr: "पाठवत आहे…" },
  "pd.sendInterest": { en: "Send interest", hi: "रुचि भेजें", mr: "स्वारस्य पाठवा" },
  "pd.block": { en: "Block", hi: "ब्लॉक", mr: "ब्लॉक" },
  "pd.report": { en: "Report", hi: "रिपोर्ट", mr: "तक्रार" },
  "pd.reportWhy": { en: "Why are you reporting?", hi: "रिपोर्ट का कारण?", mr: "तक्रारीचे कारण?" },
  "pd.about": { en: "About", hi: "परिचय", mr: "परिचय" },
  "pd.family": { en: "Family", hi: "परिवार", mr: "कुटुंब" },
  "pd.lookingFor": { en: "Looking for", hi: "खोज रहे हैं", mr: "शोधत आहे" },
  "pd.aiCompat": { en: "AI Compatibility", hi: "AI संगति", mr: "AI सुसंगती" },
  "pd.aiReveal": { en: "Reveal compatibility", hi: "संगति देखें", mr: "सुसंगती पहा" },
  "pd.aiAnalysing": { en: "Analysing…", hi: "विश्लेषण…", mr: "विश्लेषण…" },
  "pd.kundli": { en: "Kundli Match", hi: "कुंडली मिलान", mr: "कुंडली जुळवणी" },
  "pd.kundliCheck": { en: "Check harmony", hi: "मेल देखें", mr: "जुळणी पहा" },
};

export function translate(key, lang) {
  const entry = dict[key];
  if (!entry) return key;
  return entry[lang] || entry.en || key;
}
